<template>
  <fn-page-container>
    <fn-contact-confirmation
      :page="page"
      :image="confirmationImage"
    />
  </fn-page-container>
</template>

<script setup lang="ts">
import confirmationImage from '@/assets/img/contactconfirmation.jpg';

definePageMeta({
  name: 'orders-help-confirmation',
  middleware: ['requires-hard-login', 'authenticated'],
});

const { page } = await getMyAccountSubPageAsyncData('my-account/orders/help/confirmation');

usePageMeta({ page });
</script>
